export default "__VITE_ASSET__CvVCQJMC__"